// extracted by css-extract-rspack-plugin
export default {"menuItem":"u3KVu1gmS8QMeC8w","publishItem":"iHeIjNfz_JgEjw5I","publishItemStatus":"op0FvuNa_BoL113A"};